import React, { createContext, useContext, useState } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState({ quantity: 0, total: 0 });
    const price = 39.99;

    const addToCart = () => {
        setCart(prev => {
            const newCart = {
                quantity: prev.quantity + 1,
                total: (prev.quantity + 1) * price
            };
            return newCart;
        });
    };

    const updateQuantity = (delta) => {
        setCart(prev => {
            const newQty = Math.max(0, prev.quantity + delta);
            const newCart = {
                quantity: newQty,
                total: newQty * price
            };
            return newCart;
        });
    };


    const clearCart = () => {
        setCart({ quantity: 0, total: 0 });
    };
    // Log when cart changes
    return (
        <CartContext.Provider value={{ cart, addToCart, updateQuantity, clearCart }}>
            {children}
        </CartContext.Provider>
    );
};

